<app-header></app-header>
<h1>Takk fyrir að bóka skíðakennslu. Við munum hafa samband með tölvupósti innan 24 tíma.</h1>
